import * as React from "react";
import ReserveTime from "./ReserveTime";
export function AdminView(props: { index: Number; value: number }) {
  return <div>{props.value === props.index && <ReserveTime />}</div>;
}
export default AdminView;
